import {
	CompanySignupInterface,
	ContactUsInitialValues,
	ForgotPasswordInterface,
	ResetPasswordInterface,
	SignInInterface,
	SignupInterface,
	updateSocialSignupInterface,
	UserCreateProfileInterface,
} from 'constants/interfaces/authInterface';
import * as Yup from 'yup';

// Initial Values
export const signInInitialValues: SignInInterface = {
	email: '',
	password: '',
	rememberMe: false,
};

export const signupInitialValues: SignupInterface = {
	firstName: '',
	lastName: '',
	email: '',
	phoneNumber: '',
	countryCode: '91',
	cityId: null,
	stateId: null,
	countryId: null,
	address: '',
	password: '',
	confirmPassword: '',
	agreeTerms: false,
	newsletter: false,
	profilePicture: '',
	gender: '',
};

export const UpdateSocialSignupInitialValues: updateSocialSignupInterface = {
	firstName: '',
	lastName: '',
	email: '',
	phoneNumber: '',
	countryCode: '',
	cityId: null,
	stateId: null,
	countryId: null,
	address: '',
};

export const companySignupInitialValues: CompanySignupInterface = {
	companyName: '',
	websiteLink: '',
	email: '',
	phoneNumber: '',
	countryCode: '',
	cityId: null,
	stateId: null,
	countryId: null,
	address: '',
	password: '',
	confirmPassword: '',
	agreeTerms: false,
	profilePicture: '',
	newsletter: false,
};

export const forgotPasswordInitialValues: ForgotPasswordInterface = {
	email: '',
};

export const resetPasswordInitialValues: ResetPasswordInterface = {
	password: '',
	confirmPassword: '',
};

export const userProfileInitialValues: UserCreateProfileInterface = {
	avatar: '',
	ageGroup: '',
	country: '',
	city: '',
	deviceToken: 'test',
};

export const contactUsInitialValues: ContactUsInitialValues = {
	fullName: '',
	email: '',
	phone: '',
	description: '',
};

type TranslateFunction = (key: string, params?: Record<string, string>) => string;

// Validation Schemas
export const signInSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		email: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.email') }))
			.email(translate('Validation.email'))
			.matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, translate('Validation.email')),
		password: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.password') }))
			.min(6, translate('Validation.passwordMustBeAtleast')),
	});

export const signupSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		firstName: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.firstName') }))
			.trim(),
		lastName: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.lastName') }))
			.trim(),
		/* gender: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.gender') }))
			.oneOf(['male', 'female', 'diverse'], translate('Validation.invalidGender')), */
		email: Yup.string()
			.required(translate('Validation.required', { field: translate('Resume.email') }))
			.email(translate('Validation.email'))
			.matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, translate('Validation.email')),
		profilePicture: Yup.mixed()
			.required(
				translate('Validation.required', { field: translate('Profile.uploadProfilePicture') }),
			)
			.test('fileType', translate('Validation.invalidFileType'), (value) => {
				if (!value) return false; // now required
				if (typeof value === 'string') return true; // allow string (URL or empty)
				if (value instanceof File) {
					return !!(value.type && value.type.startsWith('image/'));
				}
				return false;
			})
			.test('fileSize', translate('Validation.imageSize5MB'), (value) => {
				if (!value) return true; // not required for size, only for presence
				if (typeof value === 'string') return true; // allow string (URL or empty)
				if (value instanceof File) {
					return value.size <= 5 * 1024 * 1024; // 5MB
				}
				return false;
			}),
		phoneNumber: Yup.string()
			// .required(translate('Validation.required', { field: translate('PlaceHolder.phone') }))
			.min(5, translate('Validation.phoneNumberMustBeAtleast'))
			.max(
				12,
				translate('Validation.max', { field: translate('PlaceHolder.phone'), number: '12' }),
			),
		address: Yup.string().required(
			translate('Validation.required', { field: translate('PlaceHolder.location') }),
		),
		cityId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.cityId') }),
		),
		stateId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.StateId') }),
		),
		countryId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.countryId') }),
		),
		password: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.password') }))
			.min(6, translate('Validation.passwordMustBeAtleast')),
		confirmPassword: Yup.string()
			.oneOf([Yup.ref('password')], translate('Validation.passwordsMustMatch'))
			.required(
				translate('Validation.required', { field: translate('PlaceHolder.confirmPassword') }),
			), // PlaceHolder.confirmPassword
		agreeTerms: Yup.boolean().oneOf([true], translate('Validation.mustAgreeTerms')),
	});

export const updateSocialSignupSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		firstName: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.firstName') }))
			.trim(),
		lastName: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.lastName') }))
			.trim(),
		email: Yup.string()
			.required(translate('Validation.required', { field: translate('Resume.email') }))
			.email(translate('Validation.email'))
			.matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, translate('Validation.email')),
		phoneNumber: Yup.string()
			// .required(translate('Validation.required', { field: translate('PlaceHolder.phone') }))
			.min(5, translate('Validation.phoneNumberMustBeAtleast'))
			.max(
				12,
				translate('Validation.max', { field: translate('PlaceHolder.phone'), number: '12' }),
			),
		address: Yup.string().required(
			translate('Validation.required', { field: translate('PlaceHolder.location') }),
		),
		cityId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.cityId') }),
		), // t("Validation.required", { title: t("PlaceHolder.confirmPassword") })
		stateId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.StateId') }),
		),
		countryId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.countryId') }),
		),
	});

export const companySignupSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		companyName: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.companyName') }))
			.min(
				5,
				translate('Validation.min', { field: translate('PlaceHolder.companyName'), number: '5' }),
			)
			.trim(),
		email: Yup.string()
			.email(translate('Validation.email'))
			.matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, translate('Validation.email'))
			.required(translate('Validation.required', { field: translate('Resume.email') })),
		profilePicture: Yup.mixed()
			.required(translate('Validation.required', { field: translate('Resume.uploadCompanyLogo') }))
			.test('fileType', translate('Validation.invalidFileType'), (value) => {
				if (!value) return false; // now required
				if (typeof value === 'string') return true; // allow string (URL or empty)
				if (value instanceof File) {
					return !!(value.type && value.type.startsWith('image/'));
				}
				return false;
			})
			.test('fileSize', translate('Validation.imageSize5MB'), (value) => {
				if (!value) return true; // not required for size, only for presence
				if (typeof value === 'string') return true; // allow string (URL or empty)
				if (value instanceof File) {
					return value.size <= 5 * 1024 * 1024; // 5MB
				}
				return false;
			}),
		phoneNumber: Yup.string()
			// .required(translate('Validation.required', { field: translate('PlaceHolder.phone') }))
			.min(5, translate('Validation.phoneNumberMustBeAtleast'))
			.max(
				12,
				translate('Validation.max', { field: translate('PlaceHolder.phone'), number: '12' }),
			),
		websiteLink: Yup.string().required(
			translate('Validation.required', { field: translate('Profile.editCompanyUrl') }),
		),
		address: Yup.string().required(
			translate('Validation.required', { field: translate('PlaceHolder.location') }),
		),
		cityId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.cityId') }),
		),
		stateId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.StateId') }),
		),
		countryId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.countryId') }),
		),
		password: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.password') }))
			.min(6, translate('Validation.passwordMustBeAtleast')),
		confirmPassword: Yup.string()
			.oneOf([Yup.ref('password')], translate('Validation.passwordsMustMatch'))
			.required(
				translate('Validation.required', { field: translate('PlaceHolder.confirmPassword') }),
			),
		agreeTerms: Yup.boolean().oneOf([true], translate('Validation.mustAgreeTerms')),
	});

export const forgotPasswordSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		email: Yup.string()
			.required(translate('Validation.required', { field: translate('Resume.email') }))
			.email(translate('Validation.email'))
			.matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, translate('Validation.email')),
	});

export const resetPasswordSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		password: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.password') }))
			.min(6, translate('Validation.passwordMustBeAtleast')),
		confirmPassword: Yup.string()
			.oneOf([Yup.ref('password')], translate('Validation.passwordsMustMatch'))
			.required(
				translate('Validation.required', { field: translate('PlaceHolder.confirmPassword') }),
			),
	});

export const contactUsSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		fullName: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.fullName') }))
			.trim(),
		email: Yup.string()
			.required(translate('Validation.required', { field: translate('Resume.email') }))
			.email(translate('Validation.email'))
			.matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, translate('Validation.email')),
		description: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.description') }))
			.trim(),
	});
